import { QueryKey, useQueryClient } from 'react-query';

export function useInvalidateQueries() {
  const qc = useQueryClient();

  return (queryKey: QueryKey) =>
    qc.invalidateQueries({
      predicate: (query) => {
        if (typeof queryKey === 'string') {
          return query.queryKey.includes(queryKey);
        } else if (Array.isArray(queryKey)) {
          const [_locationId, ...rest] = query.queryKey;

          return rest.every((key, index) => queryKey[index] === key);
        }
        return false;
      },
    });
}
